<template>
  <div class="animated fadeIn">
    <h4 class="page-title">User Profiles</h4>
    <hr />
    <div class="row">
      <div class="col">
        <div style="margin: 0 auto; width: 10px;" v-if="isFetching">
          <div class="loader-dark-blue medium mb-5 mt-5"></div>
        </div>
        <div class="mb-3" v-show="!isFetching">
          <span v-show="items.length">Number of data found: <b-badge pill variant="primary">{{items.length}}</b-badge></span>
          <b-btn class="float-right" variant="primary" size="sm" @click="add()"><i class="fa fa-plus"></i> Add</b-btn>
        </div>
        <b-alert variant="danger"
          class="text-center"
          :show="!isFetching && !items.length">
          Data is empty
        </b-alert>
        <b-table responsive hover striped :fields="fields" :items="items" :per-page="itemsPerPage" :current-page="currentPage" v-show="!isFetching && items.length">
          <template v-slot:cell(STATUS)="row">
            <span class="badge badge-sm" v-bind:class="{'badge-success': row.value, 'badge-danger': !row.value}">{{row.value ? 'ACTIVE' : 'INACTIVE'}}</span>
          </template>
          <template v-slot:cell(ACTIONS)="row">
            <b-btn variant="warning" size="sm" @click="edit(row.item)">
              <i class="fa fa-pencil-square-o"></i> Edit
            </b-btn>
          </template>
        </b-table>
        <b-pagination v-show="items.length > 10" :total-rows="items.length" :per-page="itemsPerPage" v-model="currentPage" />
      </div>
    </div>
  </div>
</template>
<script>
import { server, fieldsService } from '@/services/'
import { UserProfilesModal } from '@/components/modals/'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'user-profiles',
  data () {
    return {
      isFetching: false,
      errorMsg: Object,
      isEmpty: false,
      // items: [],
      itemsPerPage: 10,
      currentPage: 1,
      itemsCount: 0,
      fields: fieldsService.USER_PROFILES
    }
  },
  components: {
    UserProfilesModal
  },
  methods: {
    add () {
      this.$modal.show(UserProfilesModal, {mode: 'Add'}, {height: 'auto'});
    },
    edit (obj) {
      this.$modal.show(UserProfilesModal, {mode: 'Edit', model: obj, caller: 'profiles'}, {height: 'auto'});
    }
  },
  computed: mapState({
    items: state => state.userProfile.items
  }),
  created () {
    this.$store.cache.dispatch('userProfile/getAll')
  }
}
</script>
